var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2504_5802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#DC065F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8611 17.1429C7.34726 17.1429 6.92857 16.7143 6.92857 16.2C6.92857 15.9429 7.02275 15.701 7.20942 15.5286L10.5044 12L7.20942 8.48571C7.02275 8.31334 6.92857 8.08571 6.92857 7.82857C6.92857 7.31429 7.34726 6.88571 7.8611 6.88571C8.13873 6.88571 8.35714 6.97989 8.54381 7.16667L12 10.4762L15.4562 7.16667C15.6603 6.97989 15.8787 6.88571 16.142 6.88571C16.6558 6.88571 17.0745 7.31429 17.0745 7.82857C17.0745 8.08571 16.9946 8.31334 16.7905 8.52857L13.4956 12L16.7619 15.5143C16.9538 15.701 17.0479 15.9286 17.0479 16.2C17.0479 16.7143 16.6149 17.1429 15.973 17.1429C15.7107 17.1429 15.4671 17.0488 15.2947 16.8857L12 13.5714L8.71938 16.8857C8.54701 17.0488 8.3034 17.1429 7.8611 17.1429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2504_5802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotificationIcon);
export default __webpack_public_path__ + "static/media/error-notification-icon.dd28f6d2c14f60f55f84ff548813a8d6.svg";
export { ForwardRef as ReactComponent };